// subscriptionHelper.js
import { regSw, subscribe } from './helper';

export async function registerAndSubscribe(username,total) {
  try {
    
    console.log("registerAndSubscribe",username,total);
    const serviceWorkerReg = await regSw();
    if (!serviceWorkerReg) {
      console.warn('Service worker not available; skipping push subscription.');
      return;
    }
    await subscribe(serviceWorkerReg,username,total);
  } catch (error) {
    console.log(error);
  }
}
